export const contactForm = {
	id: 'discover',
	lightBg: true,
	lightText: false,
	lightTextDesc: false,
	topLine: 'Company',
	headline: 'Indigenous Iron Story',
	description: 'Cody is a Tsleil-Waututh First Nation Community member. He has extensive civil construction project experience, and the last few years have been productive in a senior development management role with KFN Enterprises. He owns and manages several businesses (including Indigenous Iron Construction) and specializes in Indigenous partnerships and maximizing opportunities and benefits for Indigenous businesses through large public sector projects.',
	buttonLabel: "We're Hiring! Click Here To Apply",
	imgStart: false,
	alt: 'Planet',
	dark: false,
	primary: false,
	darkText: true,
}
